import * as React from "react";
import { LineChart, XAxis, YAxis, CartesianGrid, Line, Tooltip, ResponsiveContainer } from "recharts";
import * as moment from "moment";
import {isIE} from '../../utils';

interface IProps {
    data: any[];
    interval?: number;
    isFundPage?: boolean;
    labels?: string[];
}

export class PerformanceChart extends React.Component<IProps, {}>{
    constructor(props) {
        super(props);
    }

    render() {
        let { data, labels, interval } = this.props;
        let colors = ["#004f5c", "#9ea900", "#943840", "#42739b", "#cc9933"];
        let dateFormatterAxis = (value) => moment(value).format('MMM YY');
        let dateFormatterTooltip = (value) => moment(value).format('DD MMM YYYY');

        let minValue;
        let maxValue;
        let deltaMinMax;
        let isInternetExplorer = isIE();
        if(data){
            data.forEach((dataAtDate) => {
                Object.keys(dataAtDate).forEach((key) => {
                    let value = dataAtDate[key];
                    //If value is a number
                    if (!isNaN(value)) {
                        if (!maxValue || value > maxValue) {
                            maxValue = value;
                        } else if (!minValue || value < minValue) {
                            minValue = value;
                        }
                    }
                })
            })
            deltaMinMax = maxValue - minValue;
        }

        let yaxisFormatter = (value) => {
            //Custom y axis tick formatting due to bug in Recharts: JIRA SB-8880
            if (isInternetExplorer && deltaMinMax) {
                if (deltaMinMax > 5) {
                    return value.toFixed(0);
                } else if (deltaMinMax > 1) {
                    return value.toFixed(2);
                } else if (deltaMinMax > 0) {
                    //Find first index of a significant figure
                    let indexOfFirstSignificantFigure;
                    let deltaMinMaxString = deltaMinMax.toString();
                    for (let i = 0; i < deltaMinMaxString.length; i++) {
                        let figure = deltaMinMaxString[i];
                        if ((figure !== '.') && (figure !== '0') && !indexOfFirstSignificantFigure) {
                            indexOfFirstSignificantFigure = i;
                        }
                    }
                    //We can use indexOfFirstSignificantFigure as it is due to the '0.' at the start of the number adding some padding to the index
                    return value.toFixed(indexOfFirstSignificantFigure);
                } else {
                    //deltaMinMax is zero
                    return value;
                }
            } else {
                return value;
            }
        }

        return (
            <div>
                <ResponsiveContainer width="100%" height="100%" minHeight={350} >
                    <LineChart data={data} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                        <XAxis dataKey="date" tickFormatter={dateFormatterAxis} interval={interval} />
                        <YAxis tickFormatter={yaxisFormatter} type="number" domain={["auto", "dataMax"]} />
                        <Tooltip labelFormatter={dateFormatterTooltip} formatter={value => value.toFixed(2)} />
                        <CartesianGrid strokeDasharray="0" vertical={false} />
                        {labels.map((label, index) => (
                            <Line key={label} type="monotone" dataKey={label} stroke={colors[index]} strokeWidth={3} dot={false} connectNulls={true} isAnimationActiveBoolean={false} />
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/FundPages/PerformanceChart.tsx